export const gitCommit = 'be5bcbeb'
